var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7368 9.26313H1.26316C0.928829 9.26093 0.608821 9.12713 0.372409 8.89072C0.135998 8.65431 0.00220686 8.3343 0 7.99997C0.00220686 7.66565 0.135998 7.34564 0.372409 7.10923C0.608821 6.87281 0.928829 6.73902 1.26316 6.73682H14.7368C15.0712 6.73902 15.3912 6.87281 15.6276 7.10923C15.864 7.34564 15.9978 7.66565 16 7.99997C15.9978 8.3343 15.864 8.65431 15.6276 8.89072C15.3912 9.12713 15.0712 9.26093 14.7368 9.26313Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73684 14.7368L6.73684 1.26313C6.73905 0.928803 6.87284 0.608795 7.10925 0.372383C7.34566 0.135972 7.66567 0.00218104 8 -2.58044e-05C8.33433 0.00218107 8.65434 0.135972 8.89075 0.372383C9.12716 0.608795 9.26095 0.928803 9.26316 1.26313L9.26316 14.7368C9.26095 15.0711 9.12716 15.3912 8.89075 15.6276C8.65434 15.864 8.33433 15.9978 8 16C7.66567 15.9978 7.34566 15.864 7.10925 15.6276C6.87284 15.3912 6.73905 15.0711 6.73684 14.7368Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8dd20c3f2d283d999a5371ce6f8bfa2f.svg";
export { ForwardRef as ReactComponent };